import { Injectable } from '@angular/core';
import { ReturnStatement } from '@angular/compiler';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  //saveDataInStorage for store all user data in localStorage...
  saveDataInStorage(data : any){
    if(data) {
      localStorage.setItem('userData',JSON.stringify(data));
    } 
  }
  
  //fetchUserStorageData function for get all localStorage data...
  fetchUserStorageData(){
    try {
      return JSON.parse(localStorage.getItem('userData'));
    } catch (error) {
      return null;      
    }
  }

  //fetchUserStorageData function for get all localStorage data...
  DeleteUserStorageData(){
    localStorage.removeItem('userData');
  }

  //getUserToken for getusertoken..
  getUserToken(){
    return localStorage.getItem('token');
  }

  setToken(token){
    localStorage.setItem('token',token);
  }

  //deleteUserToken for delete token.. 
  deleteUserToken(){
    this.setToken('');
  }

  getUserRole(){
    const data  = <any>this.fetchUserStorageData();
    return data.role; 
  }
}
